import { useEffect, useRef, useState } from 'react'
import { useTreeState } from './treeState.context'

export const useTreeNodeChildren = (id: string) => {
  const treeState = useTreeState()
  const [children, setChildren] = useState(treeState.tree.getChildren(id))

  const childrenRef = useRef(children)
  childrenRef.current = children

  useEffect(() => {
    // It is possible that children were updated after the render but before
    // the effect is executed. So we need to make an extra check here.
    const currentChildren = treeState.tree.getChildren(id)
    if (currentChildren.length !== childrenRef.current.length) {
      setChildren(currentChildren)
    }

    const unsubscribe = treeState.registerUpdateListener(id, reason => {
      if (reason === 'setChildren') {
        setChildren(treeState.tree.getChildren(id))
      }
    })

    return unsubscribe
  }, [id, treeState])

  return children
}
